import { Skeleton, Tabs, TabsList, TabsTrigger } from 'app-template-lib/components/shadcn';
import { ToWarekiFormatter } from '../../../../utils/toWarekiFormatter';

interface ISkeletonCardProps {
    // 設定取得済みで年度タブのラベルだけ先に出せる場合に渡す
    createdYear?: number;
    selectedYear?: string;
    onSelectYear?: (year: string) => void;
}

export function SkeletonCard({ createdYear, selectedYear, onSelectYear }: ISkeletonCardProps = {}) {
    return (
        <div className="flex flex-col space-y-3">
            <section>
                <Skeleton className="h-[50px] w-full rounded-xl m-2 mt-8" />
            </section>
            <div className="grid gap-4 grid-col-1 md:grid-cols-7">
                <Skeleton className="h-[300px] w-full col-span-4 rounded-xl m-2 " />
                <Skeleton className="h-[300px] w-full col-span-3 rounded-xl m-2 " />
            </div>

            <div>
                <section className="pt-4">
                    {createdYear ? (
                        <Tabs value={selectedYear} onValueChange={onSelectYear}>
                            <TabsList className="w-full">
                                {[3, 2, 1, 0].map((offset) => (
                                    <TabsTrigger key={offset} value={String(createdYear - offset)} className="w-1/4" disabled>
                                        {ToWarekiFormatter(createdYear - offset)}
                                    </TabsTrigger>
                                ))}
                            </TabsList>
                        </Tabs>
                    ) : (
                        <Skeleton className="h-[50px] w-full rounded-xl m-2" />
                    )}
                </section>
                <section>
                    <Skeleton className="h-[300px] w-full rounded-xl m-2 " />
                </section>
            </div>
        </div>
    );
}
